import OpenAPIChangelog from './OpenAPIChangelog';

export default OpenAPIChangelog;
